import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { LiteratureRevisionEstrutura } from "@model/LiteratureRevisionEstrutura";
import { Topic } from "@model/Topic";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DevelopmentService } from "@service/development.service";
import { ToastrService } from "ngx-toastr";
import { Document, Packer, PageNumberFormat, Paragraph, TextRun } from "docx";

@Component({
  selector: "app-modal-literature-revision",
  templateUrl: "./modal-literature-revision.component.html",
  styleUrls: ["./modal-literature-revision.component.scss"],
})
export class ModalLiteratureRevisionComponent implements OnInit {
  @ViewChildren("textEditor") textEditor: QueryList<ElementRef>;
  public topics: Array<Topic> = [];
  public selectedTopic: { tema: string; id: number };
  public showTextEditor: boolean = true;
  private literatureRevisionId: number = null;
  public editorConfig: any;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { projectId: number; selectedText: string },
    public dialogRef: MatDialogRef<ModalLiteratureRevisionComponent>,
    private developmentService: DevelopmentService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.editorConfig = {
      height: "250",
      enterMode: "2",
      allowedContent: true,
      extraPlugins: "divarea",
      toolbar: [
        {
          name: "clipboard",
          items: [
            "citationButton",
            "Cut",
            "Copy",
            "pasteFromWordButton",
            "-",
            "Undo",
            "Redo",
          ],
        },
        {
          name: "paragraph",
          items: [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
          ],
        },
        { name: "basicstyles", items: ["Bold", "Italic", "Underline", "-"] },
        { name: "styles", items: ["Font", "FontSize"] },
        { name: "colors", items: ["TextColor", "BGColor"] },
      ],
    };
  }

  ngAfterViewInit() {
    this.developmentService
       .getLiteratureRevision(this.data.projectId)
       .subscribe((res) => {
         console.log("topics", res.topics);
         this.literatureRevisionId = res.id;
         res.topics.forEach((topic, index) => {
           if (topic.literatureRevisionStruct.estruturaName === null) {
             topic.literatureRevisionStruct.estruturaName = "";
           }
   
           if (topic.topics && topic.topics.length > 0 && topic.topics[0] === null) {
             topic.topics[0] = "";
           }
   
           this.topics.push(topic);
           let firstTopic: { tema: string; id: number };
           if (index === 0) {
             firstTopic = {
               tema: topic.literatureRevisionStruct.tema,
               id: topic.literatureRevisionStruct.id,
             };
           }
           this.selectedTopic = sessionStorage.getItem('lastSelectedTopic') ? JSON.parse(sessionStorage.getItem('lastSelectedTopic')) : firstTopic;
         });
       });
   }
   

  topicIndex(): number {
    return this.topics
      .map((el) => el.literatureRevisionStruct.id)
      .indexOf(this.selectedTopic.id);
  }

  isFirstTopic(topicId: number): boolean {
    const index = this.topics
      .map((el) => el.literatureRevisionStruct.id)
      .indexOf(topicId);
    if (this.selectedTopic) {
      return index === this.topicIndex();
    }
    return index === 0;
  }

  addBasicStructure() {
    const basicTopics = ['INTRODUÇÃO', 'METODOLOGIA', 'RESULTADOS E DISCUSSÃO', 'CONSIDERAÇÕES FINAIS']
    basicTopics.forEach(topic => {
      const newTopic = new LiteratureRevisionEstrutura(
        this.topics.length > 0
          ? this.topics[this.topics.length - 1].literatureRevisionStruct.id + 1
          : 1,
        topic,
        0,
        "",
        0,
        0,
        0,
        0,
        0
      );
      this.topics.push({ literatureRevisionStruct: newTopic, topics: [] });
      this.topics[
        this.topics.length - 1
      ].literatureRevisionStruct.FieldTextsVisible = true;
      this.topics[
        this.topics.length - 1
      ].literatureRevisionStruct.estrutura = 0;
      this.topics[
        this.topics.length - 1
      ].literatureRevisionStruct.QtdParagrafos = 1;
      this.selectedTopic = { tema: topic, id: newTopic.id };
    })
    this.developmentService
      .saveOrUpdateLiteratureRevisions(
        this.data.projectId,
        this.topics,
        this.literatureRevisionId
      )
      .subscribe((literature_revision) => {
        if (literature_revision && literature_revision.id) {
          this.literatureRevisionId = literature_revision.id;
        }
      });
  }

  saveTopic(topicName: string) {
    if (!topicName) {
      this.toastr.error("O campo não pode ser vazio!");
      return;
    }
    let temaContains = false;
    for (let i = 0; i < this.topics.length; i++) {
      if (this.topics[i].literatureRevisionStruct.tema === topicName) {
        temaContains = true;
        this.toastr.error("Tema já existe!");
        break;
      }
    }
    if (!temaContains) {
      const topic = new LiteratureRevisionEstrutura(
        this.topics.length > 0
          ? this.topics[this.topics.length - 1].literatureRevisionStruct.id + 1
          : 1,
        topicName,
        0,
        "",
        0,
        0,
        0,
        0,
        0
      );
      this.topics.push({ literatureRevisionStruct: topic, topics: [] });
      this.topics[
        this.topics.length - 1
      ].literatureRevisionStruct.FieldTextsVisible = true;
      this.topics[
        this.topics.length - 1
      ].literatureRevisionStruct.estrutura = 0;
      this.topics[
        this.topics.length - 1
      ].literatureRevisionStruct.QtdParagrafos = 1;
      this.selectedTopic = { tema: topicName, id: topic.id };
    }

    this.developmentService
      .saveOrUpdateLiteratureRevisions(
        this.data.projectId,
        this.topics,
        this.literatureRevisionId
      )
      .subscribe((literature_revision) => {
        if (literature_revision && literature_revision.id) {
          this.literatureRevisionId = literature_revision.id;
        }
      });
  }

  showTextEditorFn() {
    if (!this.showTextEditor) {
      this.editText();
    }
    this.showTextEditor = !this.showTextEditor;
    const editor = this.textEditor.first;
    const index = this.topicIndex();
    let editorContent: string = "";
    for (let c = 0; c < this.topics[index].topics.length; c++) {
      editorContent += `${this.topics[index].topics[c]} <br>`.replace(
        /\n/g,
        "<br>"
      );
    }
    // @ts-ignore
    editor.instance.setData(editorContent);
  }

  editText() {
    const editor = this.textEditor.first;
    const index = this.topicIndex()

    // @ts-ignore
    let inputText = editor.instance.getData();
    inputText = inputText.replace(/\n/g, "");

    if (index > -1) {
      this.topics[index].topics = [];
      this.topics[index].topics.push(inputText);

      this.developmentService
        .saveOrUpdateLiteratureRevisions(
          this.data.projectId,
          this.topics,
          this.literatureRevisionId
        )
        .subscribe((literature_revision) => {
          if (literature_revision && literature_revision.id) {
            this.literatureRevisionId = literature_revision.id;
          }
          this.toastr.success("Texto editado com sucesso!");
          this.showTextEditor = !this.showTextEditor;
        });
    }
  }

  deleteTopic(): void {
    const index = this.topicIndex();

    if (index > -1) {
      this.topics[index].literatureRevisionStruct.FieldTextsVisible = false;
      this.topics.splice(index, 1);

      this.developmentService
        .saveOrUpdateLiteratureRevisions(
          this.data.projectId,
          this.topics,
          this.literatureRevisionId
        )
        .subscribe((literature_revision) => {
          if (literature_revision && literature_revision.id) {
            this.literatureRevisionId = literature_revision.id;
          }
        });
    }
  }

  saveText() {
    const index = this.topicIndex();

    if (!this.showTextEditor) {
      this.editText();
    }

    if (index > -1) {
      const selectedText = this.data.selectedText === null || this.data.selectedText === undefined ? "" : this.data.selectedText;
      if (this.topics[index].topics.length > 0) {
        this.topics[index].topics[0] += `${this.data.selectedText}`;
      } else {
        this.topics[index].topics = [];
        this.topics[index].topics[0] = this.data.selectedText;
      }

      this.developmentService
        .saveOrUpdateLiteratureRevisions(
          this.data.projectId,
          this.topics,
          this.literatureRevisionId
        )
        .subscribe((literature_revision) => {
          if (literature_revision && literature_revision.id) {
            this.literatureRevisionId = literature_revision.id;
          }
          this.toastr.success("Texto salvo com sucesso!");
        });
    }
    this.dialogRef.close();
  }

  exportDocx() {
    const index = this.topicIndex();
    const doc = new Document();
    doc.addSection({
      properties: {
        pageNumberStart: 1,
        pageNumberFormatType: PageNumberFormat.DECIMAL,
      },
      children: [
        new Paragraph({
          children: [
            new TextRun(this.topics[index].topics[0])
          ]
        })
      ],
    });

    // Used to export the file into a .docx file
    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "Extração de Conteúdo.docx");
    });
  }

  getSelectedOption(event: { tema: string; id: number }) {
    if (!this.showTextEditor) {
      this.editText();
    }
    this.selectedTopic = event;
    sessionStorage.setItem('lastSelectedTopic', JSON.stringify(event));
  }
}